export const environment = {
  production: true,

  authRedirectURI: 'https://portfoliopentest.reconcept.nl/login/success/',
  canChangeBE: true,
};
